import { render, staticRenderFns } from "./RefundNew.vue?vue&type=template&id=2e810d61&scoped=true&"
import script from "./RefundNew.vue?vue&type=script&lang=js&"
export * from "./RefundNew.vue?vue&type=script&lang=js&"
import style0 from "./RefundNew.vue?vue&type=style&index=0&id=2e810d61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e810d61",
  null
  
)

export default component.exports